import { useEffect } from 'react';

export function usePageTitle(title: string) {
  useEffect(() => {
    const original = document.title;
    document.title = title;
    return () => {
      document.title = original;
    };
  }, [title]);
}